<template>
  <div>
    <!-- {{ maxWidth }}-{{ maxHeight }} -->
    <v-img
      v-if="imageFile"
      :src="medImagePath + imageFile"
      :max-height="maxHeight"
      :max-width="maxWidth"
      contain
      class="ma-1 px-2 medPackageImage"
      :lazy-src="require(`@/assets/images/${lazyImage}.svg`)"
    />
    <default-package-image
      v-else
      :kind="productForm"
      :height="getDefaultHeight"
      :width="maxWidth"
    ></default-package-image>
  </div>
</template>

<script>
// import Name from "../dir/file";
import DefaultPackageImage from "./DefaultPackageImage";

export default {
  name: "MedPackageImage",
  components: {
    DefaultPackageImage,
  },
  props: {
    imageFile: null,
    productForm: null, // solution, gel, ointment, injection, oral...
    maxWidth: {
      type: Number,
      default: 250,
    },
    maxHeight: {
      type: Number,
      default: 250,
    },
    defaultHeight: {
      type: Number,
      default: null,
    },
  },
  data: function () {
    return {
      medImagePath: "https://www.eyedock.com/fdaMeds/media/",
    };
  },
  methods: {},
  computed: {
    getDefaultHeight: function () {
      return this.defaultHeight ? this.defaultHeight : this.maxHeight;
    },
    lazyImage: function () {
      let img = "bottle_icon";
      if (this.productForm == "oral") img = "oral_bottle_icon";
      return img;
    },
  },
};
</script>

<style scoped>
/* .medPackageImage >>> .v-responsive__content {
  border-radius: 3px;
  box-shadow: 0px 0px 10px #0000001c;
} */
</style>
